<!-- 測試訊息用 -->
<!--  <button type="button" (click)="shownoty(1)">訊1</button>
<button type="button" (click)="shownoty(2)">訊2</button>
<button type="button" (click)="shownoty(3)">訊3</button> -->
<div *ngIf="!isLoaded&&!isDebug" class="loading">Loading...</div>
<app-brand-loading-mask
    *ngIf="!isLoaded&&isDebug"
    [separateForDialog]="showConfirm || (isEasyFormShown$ | async)">
</app-brand-loading-mask>
<div *ngIf="isLoaded" (click)="hideMenu()"
    style="display: flex;flex-direction: column;height: 100%;overflow:hidden;">
    <app-header></app-header>
    <app-pet-pairing *ngIf="isPatientInfoClinic && enableDesktopPet" [suspended]="showGuard"></app-pet-pairing>
    <!--麵包穴-->
    <div class="page-title" *ngIf="isShowPageTitle" [hidden]="!pageTitle">
        <div class="navigation">
            {{pageTitle}}
        </div>
        <div class="marqueeDiv"  >
          <marquee width="88%" *ngIf="isopened&&isShowMarquee" style="color: red;font-size: 15.5px;" hspace="30" scrollamount="5" (click)="onClickMarquee()">
            系統於 2024/09/21(六)23點 ~ 2024/09/22(日)7點 配合微軟進行機房轉移作業，轉移過程會暫時停止系統服務，如作業提前完成，將會提前恢復服務，造成您的不便，敬請見諒。
          </marquee>
        </div>

        <div [ngClass]="isShowMarquee?'font-controller-marquee':'font-controller'">
          <a type="button" [title]="'跑馬燈顯示/隱藏'" style="width: 100px; font-size: 14px;"
             (click)="onDoubleClick()" class="rect-btn" *ngIf="isShowMarquee">
            跑馬燈{{isopened?'顯示':'隱藏'}}<mat-icon *ngIf="isopened" class="vis-combine-icon">notifications</mat-icon>
            <mat-icon *ngIf="!isopened" class="vis-combine-icon">notifications_off</mat-icon>
          </a>
            <app-icon-font class="position-relative cursor-pointer w-16"
                (click)="getFontGreater($event)"
                [cssName]="fontGreater?'font-great-on':'font-great-off'">
            </app-icon-font>
        </div>
    </div>
<!--[ngClass]="layoutForMenuCssClass"-->
    <div style="flex-grow: 1;" class="container-fluid main-layout-container" >
        <!-- <div class="left-menu" [hidden]="!isShowMenu" *ngIf="isUseLeftMenu">
            <app-menu [isVertical]="true"></app-menu>
        </div> -->

        <div class="main-content" [ngClass]="[isHist?'is-hist':'']" #mainContent>

            <router-outlet></router-outlet>
            <app-patient-info-window
                *ngIf="patientInfoWindowState.visible && isPatientInfoClinic"
                [selectedPatient]="patientInfoWindowState.selectedPatient"
                [selectedRegisterItem]="patientInfoWindowState.selectedRegisterItem"
                [patientId]="patientInfoWindowState.patientId"
                [enableEdit]="patientInfoWindowState.enableEdit !== false"
                [memoryScope]="patientInfoWindowState.memoryScope || 'global'"
                [refreshToken]="patientInfoWindowState.refreshToken || 0"
                [refreshPatientId]="patientInfoWindowState.refreshPatientId || 0"
                (selectedPatientChange)="onPatientInfoSelectedPatientChange($event)"
                (editPatient)="onPatientInfoEditPatient($event)"
                (reservePatient)="onPatientInfoReservePatient($event)"
                (dentalFollow)="onPatientInfoDentalFollow($event)"
                (layoutChange)="onPatientInfoLayoutChange($event)"
                (resizeStateChange)="onPatientInfoResizeStateChange($event)">
            </app-patient-info-window>
        </div>
    </div>
</div>
<div *ngIf="showGuard" class="screen-guard">
    <div *ngIf="screenGuardType==1" class="controlled-font-size-xl">
        (請移動滑鼠已解鎖畫面)
    </div>
    <div *ngIf="screenGuardType==2" style="display: flex;flex-direction: column;" class="controlled-font-size-large">
        請輸入您的登入密碼已解鎖畫面
        <input (keyup)="check($event)">
        <span style="color: red;">{{checkResult}}</span>
    </div>
</div>
<!--列印-->
<app-report-helper *ngIf="isLoaded" #printHelper></app-report-helper>
<!-- Top Loader -->
<app-loader #loader></app-loader>
<!-- Notify -->
 <app-notify></app-notify>
<div class="snack-container" [ngClass]="notifyContainerCls">
    <ng-container *ngFor="let msg of msgs;let i = index">
        <div class="snack-message" *ngIf="msg.isAutoHide"
            [ngClass]="notifyAnimationClsName+'-delay'"
            [ngStyle]="msg.style"
            (animationstart)="onAniStart($event,i)" (animationend)="onAniEnd($event,i)"
            #snackdiv>
            <div class="snack-card" [ngClass]="msg.cssClass">
                {{msg.content}}
            </div>
        </div>
        <div class="snack-message" *ngIf="!msg.isAutoHide"
             [ngStyle]="msg.style"
            (animationstart)="onAniStart($event,i)" (animationend)="onAniEnd($event,i)"
            #snackdiv>
            <div class="snack-card" [ngClass]="msg.cssClass">
                <div style="width: calc(100% - 80px)">
                    {{msg.content}}
                </div>
                <button *ngIf="msg.onMoreClick" mat-button class="snack-detail vis-btn-alert" (click)="executeMoreClick(msg)">詳細</button>
                <button mat-button class="snack-ok vis-btn-alert" (click)="closeMsg(snackdiv,i)">確定</button>
            </div>
        </div>
    </ng-container>
</div>
<!--Confirm-->
<app-vis-dialog [fitContent]="confirmContent.fitContent" [show]="showConfirm" [width]="confirmDiagWidth" [title]="confirmContent.title"
                [showCloseBtn]="confirmContent.showCloseBtn"
        (close)="onCustomConfirm(null)" (open)="onConfirmOpen()">
    <div style="display: flex;align-items: center;">
        <div *ngIf="confirmContent.wait=='wait'" style="width: 100px;height: 100px;position: relative;">
            <div class="loader-default"></div>
        </div>
        <div *ngIf="confirmContent.wait=='done'" style="width: 100px;height: 100px;position: relative;">
            <mat-icon style="color: limegreen;font-size: 83px;
            height: 83px;
            width: 83px;
            margin: 9px;">check_circle_outline</mat-icon>
        </div>

        <div *ngIf="confirmContent.wait=='fail'" style="width: 100px;height: 100px;position: relative;">
            <mat-icon style="color: red;font-size: 83px;
            height: 83px;
            width: 83px;
            margin: 9px;">error_outline</mat-icon>
        </div>

        <ng-container  *ngIf="confirmContent.msg" >
            <ng-container *ngIf="confirmContent.htmlMsg;else textMsg">
                <div style="line-height: 1.2; padding: 10px 15px; white-space: pre-line; overflow-x: hidden; overflow-y: auto;line-break: anywhere; max-height: 500px; width: 100%;" class="extend-msg controlled-font-size-middle"
                    [innerHtml]="confirmContent.msg |safeHtml"></div>
            </ng-container>
            <ng-template #textMsg>
                <div style="line-height: 1.2; padding: 10px 15px; white-space: pre-line; overflow-x: hidden; overflow-y: auto;line-break: anywhere; max-height: 500px; width: 100%;" class="extend-msg controlled-font-size-middle">
                    {{confirmContent.msg}}
                </div>
            </ng-template>
        </ng-container>
    </div>

    <ng-container *ngIf="confirmContent.template!=null">
        <ng-container *ngTemplateOutlet="confirmContent.template;context:{$implicit:confirmContent.templateData}"></ng-container>
    </ng-container>
    <app-vis-dialog-actions *ngIf="confirmDiagHasAction">
        <ng-container *ngIf="confirmContent.customBtnStart">
            <ng-container *ngFor="let btn of confirmContent.customBtnStart; let i = index">
                <button type="button" [ngClass]="btn.btnCls" [matTooltip]="btn.tooltip" (click)="onCustomConfirm(btn.return)"
                 [disabled]="!showConfirm"
                [class.default-button]="confirmContent.focus === 'start' + i"
                #confirmDialogSt>{{btn.text}}<mat-icon *ngIf='btn.icon' [attr.title]='btn.tooltip' style='width: 14px; height: 14px; font-size: 14px; line-height: 14px; vertical-align: top; position: relative; top: -4px; margin-left: 2px;'>{{btn.icon}}</mat-icon></button>
            </ng-container>
        </ng-container>

        <button type="button" i18n="@@Ok" *ngIf="!confirmContent.hideYes" (click)="onCustomConfirm(true)"
            [attr.disabled]="confirmContent.disableYes?'':null"
            [disabled]="!showConfirm"
            [class.default-button]="confirmContent.focus === true"
         #confirmDialogYes>{{confirmContent.textYes||'是'}}
        </button>
        <ng-container *ngIf="confirmContent.customBtnMid">
            <ng-container *ngFor="let btn of confirmContent.customBtnMid; let i = index">
                <button type="button" [matTooltip]="btn.tooltip" (click)="onCustomConfirm(btn.return)"
                [disabled]="btn.disabled || !showConfirm"
                [class.default-button]="confirmContent.focus === 'mid' + i"
                #confirmDialogMid>{{btn.text}}<mat-icon *ngIf='btn.icon' [attr.title]='btn.tooltip' style='width: 14px; height: 14px; font-size: 14px; line-height: 14px; vertical-align: top; position: relative; top: -4px; margin-left: 2px;'>{{btn.icon}}</mat-icon></button>
            </ng-container>
        </ng-container>
        <button type="button" i18n="@@No" *ngIf="!confirmContent.hideNo" (click)="onCustomConfirm(false)"
            [disabled]="!showConfirm"
            [class.default-button]="confirmContent.focus === false"
            #confirmDialogNo>{{confirmContent.textNo||'否'}}
        </button>
        <ng-container *ngIf="confirmContent.customBtnEnd">
            <ng-container *ngFor="let btn of confirmContent.customBtnEnd; let i = index">
                <button type="button" i18n="@@Ok" [matTooltip]="btn.tooltip" (click)="onCustomConfirm(btn.return)"
                [disabled]="!showConfirm"
                [class.default-button]="confirmContent.focus === 'end' + i"
               #confirmDialogEnd>{{btn.text}}<mat-icon *ngIf='btn.icon' [attr.title]='btn.tooltip' style='width: 14px; height: 14px; font-size: 14px; line-height: 14px; vertical-align: top; position: relative; top: -4px; margin-left: 2px;'>{{btn.icon}}</mat-icon></button>
            </ng-container>
        </ng-container>
    </app-vis-dialog-actions>
    <app-vis-dialog-actions *ngIf="confirmContent.footerTemplate!=null">
        <ng-container *ngTemplateOutlet="confirmContent.footerTemplate;context:{$implicit:confirmContent.footerTemplateData}"></ng-container>
    </app-vis-dialog-actions>
</app-vis-dialog>

<app-vis-dialog [show]="getErrorStatus()!==0" [width]="250" [height]="200" [title]="'Warning'" (close)="onCustomConfirmClose()">
     <span>{{getErrorMsg()}}</span>
    <app-vis-dialog-actions>
        <button type="button" i18n="@@Ok" (click)="onConfirm(getErrorStatus())"> Ok</button>
    </app-vis-dialog-actions>
</app-vis-dialog>



<app-patients-patient-query-dialog [isDialogOpened]="isPatientDialogOpened"
    [initCondition]="initCondition"
    (onEmitResult)="onPatientDialogClose($event)"
    (onEmitQueryNotFound)="onPatientQueryNotFound($event)">
</app-patients-patient-query-dialog>

<app-msg-text textId="MSG_MainLayout1" i18n="@@MSG_MainLayout1">取得資料失敗</app-msg-text>
<app-msg-text textId="MSG_MainLayout2" i18n="@@MSG_MainLayout2">成功</app-msg-text>
<app-msg-text textId="MSG_MainLayout3" i18n="@@MSG_MainLayout3">失敗</app-msg-text>
<app-msg-text textId="MSG_MainLayout4" i18n="@@MSG_MainLayout4">請更正無效的欄位</app-msg-text>
<app-msg-text textId="MSG_MainLayout5" i18n="@@MSG_MainLayout5">輸入參數錯誤</app-msg-text>
<app-msg-text textId="MSG_LocalReportReady" i18n="@@MSG_LocalReportReady">本地報表已準備完成.</app-msg-text>
<app-msg-text textId="MSG_LocalReportNotReady" i18n="@@MSG_LocalReportNotReady">本地報表尚未準備完成.</app-msg-text>

<!-- TIP -->
<ng-container>
    <div class="tip-container" *ngIf="tipObj">
        <div class="tip-message"  [ngStyle]="{top:tipObj.msgY+'px',left:tipObj.msgX+'px',display:tipObj.hidden?'none':'flex'}">
            <div [ngClass]="tipObj.cssCls">{{tipObj.contentFix+tipObj.content}}</div>

            <button mat-button class="tip-ok" (click)="nextTip(tipObj.name)">{{tipObj.isLast?'完成':'繼續'}}</button>
        </div>
        <div *ngIf="tipObj.showBorder" class="tip-border" [ngStyle]="tipBorderStyle"></div>
        <div class="tip-close">
            <button mat-button (click)="setTip(null)">>>>跳過</button>
        </div>
    </div>
</ng-container>

<app-vis-dialog [title]="'QRCode掃描器'" [width]="300" [minHeight]="200" (close)="qrcode.show=false" #qrcode>
    <app-qrcode-scanner *ngIf="showScanner" (onSuccess)="onQRCodeScanResult($event)"></app-qrcode-scanner>
</app-vis-dialog>
<app-vis-dialog [title]="'QRCode掃描器'" [width]="600" [minHeight]="200" (close)="qrcodeReaderDiag.show=false" #qrcodeReaderDiag>
    <app-qrcode-reader (onQRCode)="onQRCodeScanResult($event)" #qrcodeReader></app-qrcode-reader>
</app-vis-dialog>
<app-vis-dialog [title]="stockAlertDialogTitle" [height]="'72%'" [superWidth]="'80%'" [maxWidth]="'99vw'"
    [show]="isStockAlertDialogOpened" [closeOnEsc]="stockAlertCloseOnEsc" (close)="onStockAlertDialogClose()">
    <ng-container *ngIf="isStockAlertDialogOpened">
        <mat-button-toggle-group *ngIf="showBatchExpiryTab" class="stock-alert-tabs" [(ngModel)]="stockAlertTab"
            name="stockAlertTab">
            <mat-button-toggle value="lowStock">庫存不足
                <span *ngIf="stockAlertCounts?.LowStockCount > 0" class="stock-alert-badge">{{ stockAlertCounts.LowStockCount }}</span>
            </mat-button-toggle>
            <mat-button-toggle value="batchExpiry">批號效期警示
                <span *ngIf="batchExpiryAlertCount > 0" class="stock-alert-badge">{{ batchExpiryAlertCount }}</span>
            </mat-button-toggle>
            <mat-button-toggle value="inactiveBatch">閒置批號
                <span *ngIf="stockAlertCounts?.InactiveBatchCount > 0" class="stock-alert-badge badge-inactive">{{ stockAlertCounts.InactiveBatchCount }}</span>
            </mat-button-toggle>
        </mat-button-toggle-group>
        <div [hidden]="stockAlertTab !== 'lowStock'">
            <app-stock-room-list [showLowStockOnly]="true"></app-stock-room-list>
        </div>
        <div *ngIf="showBatchExpiryTab" [hidden]="stockAlertTab !== 'batchExpiry'">
            <app-stock-room-batch-list [showExpiryAlertOnly]="true" (onEmitNavigate)="onStockAlertDialogClose()"></app-stock-room-batch-list>
        </div>
        <div *ngIf="showBatchExpiryTab" [hidden]="stockAlertTab !== 'inactiveBatch'">
            <app-stocks-product-batch-inactive-list [isActive]="true" (stopped)="onInactiveBatchStopped($event)"></app-stocks-product-batch-inactive-list>
        </div>
    </ng-container>
    <app-vis-dialog-actions *ngIf="isStockAlertDialogOpened">
        <button type="button" (click)="onStockAlertDialogClose()" i18n="@@Cancel">關閉</button>
    </app-vis-dialog-actions>
</app-vis-dialog>

<!--通知音效-->
<app-notify-sound #notifySound></app-notify-sound>
